<script>
import FilePreview from '@/src/components/file-preview-image.vue'
import FilePreviewPdf from '@src/components/file-preview-pdf.vue'
import axios from 'axios'
export default {
  components: {
    FilePreview,
    FilePreviewPdf,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    attachments: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      absolute: true,
      overlay: false,
      dialog: false,
      dialogPdf: false,
      toDelete: false,
      acceptedTypes: ['jpg', 'jpeg', 'png'],
    }
  },
  computed: {
    attachmentIcon() {
      if (this.item.extension === 'pdf') {
        return 'mdi-file-pdf-outline'
      } else if (
        this.item.extension === 'jpg' ||
        this.item.extension === 'png' ||
        this.item.extension === 'jpeg'
      ) {
        return 'mdi-file-image-outline'
      } else {
        return 'mdi-file-outline'
      }
    },
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    preview() {
      if (this.item.extension === 'pdf') {
        this.dialogPdf = true
      } else {
        if (this.acceptedTypes.includes(this.item.extension)) {
          this.dialog = true
        }
      }
    },
    async download() {
      try {
        const data = await axios.get(`/api/v1/library/files/${this.item.id}`)

        const res = await fetch(data.data.url)
        const blob = await res.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'export'
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (error) {
        console.warn(error)
      }
    },
    setToDelete() {
      this.toDelete = true
    },
    deleteAttachment(id) {
      this.$emit('delete-attachment', id)
    },
  },
}
</script>

<template>
  <v-list-item
    :class="$style.rounded"
    :disabled="disabled"
    @mouseover="overlay = true"
    @mouseleave="overlay = false"
  >
    <v-list-item-icon :class="$style.attachmentIcon">
      <v-icon size="60">{{ attachmentIcon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-row no-gutters align="center">
        <span
          :class="mobile ? $style.attachmentNameMobile : $style.attachmentName"
          class="text-truncate"
          >{{ item.name }}
        </span>
      </v-row>
      <v-row no-gutters align="center" class="ml-2">
        <v-col cols="4"
          ><span :class="$style.attachmentDetails">{{ item.size }}</span></v-col
        >
        <v-col cols="8"
          ><span :class="$style.attachmentDetails">{{
            item.created_at
          }}</span></v-col
        >
      </v-row>
    </v-list-item-content>
    <v-overlay
      :value="overlay"
      :absolute="absolute"
      color="#08295A"
      opacity="0.5"
      :class="$style.overlay"
      @click="overlay = false"
    >
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="
              acceptedTypes.includes(item.extension) || item.extension === 'pdf'
            "
            :disabled="disabled"
            color="white"
            class="mt-2"
            :class="$style.overlayButton"
            v-bind="attrs"
            v-on="on"
            @click="preview"
            ><v-icon :class="$style.overlayIcon">mdi-eye-outline</v-icon></v-btn
          >
        </template>
        <span>Preview</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="disabled"
            color="white"
            class="ml-2 mt-2"
            :class="$style.overlayButton"
            v-bind="attrs"
            v-on="on"
            ><v-icon :class="$style.overlayIcon" @click="download"
              >mdi-arrow-down</v-icon
            ></v-btn
          >
        </template>
        <span>Download</span>
      </v-tooltip>

      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="disabled"
            color="white"
            class="ml-2 mr-2 mt-2"
            :class="$style.overlayButton"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon
              v-if="toDelete === false"
              :class="$style.overlayIcon"
              @click="setToDelete"
              >mdi-delete-outline</v-icon
            >
            <v-icon
              v-else
              title="Confirm Deletion"
              :class="$style.overlayIcon"
              @click="deleteAttachment(item.id)"
            >
              mdi-check
            </v-icon>
          </v-btn>
        </template>
        <span>Delete</span>
      </v-tooltip>
    </v-overlay>
    <v-dialog
      :value="dialog"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreview
        v-if="dialog"
        :attachment-id="item.id"
        :title="item.name"
        :type="item.extension"
        :src="item.url"
        :attachments="attachments"
        @closeOverlay="dialog = false"
      />
    </v-dialog>
    <v-dialog
      :value="dialogPdf"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewPdf
        v-if="dialogPdf"
        :attachment-id="item.id"
        @closeOverlay="dialogPdf = false"
      />
    </v-dialog>
  </v-list-item>
</template>

<style lang="scss" module>
@import '@design';
.rounded {
  border-radius: 10px;
}
.attachmentName {
  max-width: 250px;
  font-family: $system-default-font-family;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #262338;
  text-align: left;
  letter-spacing: 0.75px;
}
.attachmentNameMobile {
  max-width: 150px;
  font-family: $system-default-font-family;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #262338;
  text-align: left;
  letter-spacing: 0.75px;
}
.attachmentDetails {
  font-family: $system-default-font-family;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  color: #6e7191;
  text-align: center;
  letter-spacing: 0.75px;
}
.hoverColor {
  background: #08295a80;
  opacity: 50%;
}
.overlay {
  align-items: flex-start !important;
  justify-content: end !important;
}
.overlayButton {
  width: 42px !important;
  height: 33px !important;
  border-radius: 12px !important;
}
.overlayIcon {
  color: #6e7191 !important;
}
</style>
